import { Typography, Switch, Box, Grid, Button } from "@mui/material";
import { Permission } from "../../../../interfaces/common/permissions";

interface GlobalPermissionsProps {
    permissions: Permission[];
    selectedIds: number[];
    onChange: (selectedIds: number[]) => void;
}

export const GlobalPermissions: React.FC<GlobalPermissionsProps> = ({
    permissions,
    selectedIds,
    onChange,
}) => {
    const toggle = (id: number) => {
        if (selectedIds.includes(id)) {
            onChange(selectedIds.filter((i) => i !== id));
        } else {
            onChange([...selectedIds, id]);
        }
    };

    const allowAll = () => {
        const allIds = permissions.map(p => p.id);
        onChange(allIds);
    };

    const denyAll = () => {
        onChange([]);
    };

    return (
        <Box p={2} border="1px solid #e0e0e0" borderRadius={2} bgcolor="#fafafa" width={"100%"}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6">Action Based</Typography>
                <Box display="flex" gap={1}>
                    <Button size="small" variant="outlined" color="success" onClick={allowAll}>
                        Allow All
                    </Button>
                    <Button size="small" variant="outlined" color="error" onClick={denyAll}>
                        Deny All
                    </Button>
                </Box>
            </Box>

            <Grid container spacing={2}>
                {permissions.map((p) => (
                    <Grid item xs={12} sm={6} md={12} key={p.id}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            p={1}
                            bgcolor={selectedIds.includes(p.id) ? "#e6f4ea" : "#fff"}
                            borderRadius={1}
                            border="1px solid #ddd"
                        >
                            <Typography>{p.name}</Typography>
                            <Switch
                                checked={selectedIds.includes(p.id)}
                                onChange={() => toggle(p.id)}
                                color="primary"
                            />
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};
